// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Web = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Web = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Web = _exports.Web = function Web(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 2C5.5888 2 2 5.5888 2 10C2 14.4112 5.5888 18 10 18C14.4112 18 18 14.4112 18 10C18 5.5888 14.4128 2 10 2ZM16.7395 9.38574H13.8723C13.7683 7.41934 13.1713 5.42094 12.1473 3.58574C14.6433 4.42254 16.4931 6.67374 16.7395 9.38574ZM10.5059 3.25605C11.7731 5.14885 12.5186 7.29138 12.6418 9.38418H7.36172C7.48492 7.29138 8.22889 5.14885 9.49609 3.25605C9.66249 3.24325 9.8304 3.23047 10 3.23047C10.1696 3.23047 10.3379 3.24485 10.5059 3.25605ZM7.85469 3.58574C6.83069 5.42094 6.23369 7.41934 6.12969 9.38574H3.2625C3.5089 6.67374 5.35869 4.42254 7.85469 3.58574ZM3.2625 10.616H6.12969C6.23369 12.5808 6.83069 14.5792 7.85469 16.416C5.35869 15.5776 3.5089 13.3264 3.2625 10.616ZM9.49609 16.7441C8.22889 14.8497 7.48332 12.7088 7.36172 10.616H12.6418C12.5186 12.7104 11.7747 14.8513 10.5059 16.7441C10.3395 16.7569 10.1712 16.7697 10.0016 16.7697C9.83196 16.7697 9.66249 16.7569 9.49609 16.7441ZM12.1473 16.4145C13.1713 14.5793 13.7683 12.5809 13.8723 10.6145H16.7395C16.4931 13.3265 14.6433 15.5777 12.1473 16.4145Z",
      fill: "#212B36"
    }));
  };
});
